import React from 'react';
import {ItemCollection} from '@/components/compendium';
import TeaserNeuroHeadline from './TeaserNeuroHeadline';

export interface TeaserNeuroProps {
    indented?: boolean,
    highlight?: boolean,
    stairSchemaClass?: string,
    headline: React.ReactNode,
    subline?: string,
    topline?: string,
    text: React.ReactNode,
    availableAccessTechnologies?: React.ReactNode,
    ftthEarliestAvailabilityDate?: string,
    links?: React.ReactNode,
    price: React.ReactNode,
    actionLinks: React.ReactNode,
    additionalInfo?: string,
}

export default class TeaserNeuro extends React.Component<TeaserNeuroProps> {
    static Headline = TeaserNeuroHeadline;

    render() {
        const {
            indented,
            highlight,
            stairSchemaClass,
            headline,
            subline,
            topline,
            text,
            availableAccessTechnologies,
            ftthEarliestAvailabilityDate,
            links,
            price,
            actionLinks,
            additionalInfo,
        } = this.props;

        const additionalStyleClasses: string[] = [];

        if (indented) {
            additionalStyleClasses.push('teaser-indented');
        }

        if (highlight) {
            additionalStyleClasses.push('teaser-highlight');
        }

        if(stairSchemaClass) {
            additionalStyleClasses.push(stairSchemaClass);
        }

        return (
            <article className={`teaser teaser-neuro ${additionalStyleClasses.join(' ')}`}
                     data-additional-info={additionalInfo}>
                <div className="content">
                    {subline && <div className="subline" dangerouslySetInnerHTML={{__html: subline}}/>}
                    {headline}
                    {topline && <div className="topline" dangerouslySetInnerHTML={{ __html: topline }} />}
                    <div className="text">
                        {text}
                        {availableAccessTechnologies}
                        {ftthEarliestAvailabilityDate && <p dangerouslySetInnerHTML={{ __html: ftthEarliestAvailabilityDate}} />}
                    </div>
                    {links && <ItemCollection block>{links}</ItemCollection>}
                </div>
                {price}
                <ul className="links">
                    {actionLinks}
                </ul>
            </article>
        );
    }
}
